import React from 'react';
import { Divider } from 'semantic-ui-react'

const ConfSerT1 = ({autorizacUA, styles, handleClickRegr, handleClickSel1}) => {
  const a25101501 = autorizacUA.findIndex( autorizac => autorizac === "25101501" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        Configurar
        </button>
        {a25101501!==-1 &&
      <div>
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
          <i className="large calculator violet icon"></i>
          Impuestos
        </button>

        <Divider inverted />
      </div>
        }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default ConfSerT1
